import { ButtonType, Typography, UiComponentSize } from '@altibox/design-system-component-lib';
import React, { FunctionComponent } from 'react';

import { ImageProps } from 'app/components/image';
import { Link } from 'app/components/link';
import { config } from 'app/config/config';
import { i18n } from 'app/i18n';
import { I18nUtils } from 'app/utils/i18n-utils';
import { DataLayerErrorType } from 'app/data-layers/model/data-layer-error-type';
import { useErrorDataLayer } from 'app/data-layers/hooks/use-error-data-layer';
import { navigationService } from 'app/services/navigation-service';

import { StyledButton, StyledContainer, StyledImage, StyledSubtitle } from './error-cannot-order.styled';

interface Props {
    title: string;
    subtitles: string[];
    image: ImageProps;
    hideCustomerServiceText?: boolean;
    onButtonClick?: () => void;
    buttonText?: string;
    dataLayerErrorType: DataLayerErrorType;
}

export const ErrorCannotOrder: FunctionComponent<Props> = (props) => {
    const {
        subtitles,
        image,
        title,
        hideCustomerServiceText,
        buttonText = i18n.components.errorCannotOrder.goToMyPages,
        onButtonClick = () => navigationService.goToMyPages(),
        dataLayerErrorType,
    } = props;

    useErrorDataLayer(dataLayerErrorType);

    return (
        <StyledContainer>
            <Typography variant="headline2" component="h1">
                {title}
            </Typography>
            <StyledImage {...image} />
            {subtitles.map((subtitle, index) => (
                <StyledSubtitle key={index} component="p" variant="paragraph2">
                    {subtitle}
                </StyledSubtitle>
            ))}
            {!hideCustomerServiceText && (
                <StyledSubtitle variant="paragraph2" component="p">
                    {I18nUtils.richMessage(i18n.components.errorCannotOrder.contactCustomerService, {
                        link: (
                            <Link variant="paragraph2" href={config.CUSTOMER_SERVICE_URL}>
                                {i18n.components.errorCannotOrder.linkToCustomerService}
                            </Link>
                        ),
                    })}
                </StyledSubtitle>
            )}
            <StyledButton
                buttonType={ButtonType.PRIMARY_A}
                uiComponentSize={UiComponentSize.LARGE}
                onClick={onButtonClick}
            >
                {buttonText}
            </StyledButton>
        </StyledContainer>
    );
};
